import React, { useEffect } from 'react';
import { Panel } from 'rsuite';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { map, isEmpty } from 'lodash/fp';
import {
  fetchGuestVisits,
  fetchUserLocationOptions
} from '../../../../redux/sagas/routines';
import { getGuestVisitSearchQuery } from '../../../../redux/Guest/selectors/components/visit-search';
import { updateGuestVisitSearchQuery } from '../../../../redux/Guest/actions/components/visit-search';
import { getAll as getUserLocationOptions } from '../../../../redux/Guest/selectors/user-location-options';
import VisitsList from '../../../../containers/guest/VisitList';
import VisitSearch from '../../../../containers/guest/VisitSearch';

const VisitsSection = ({ guestId, ...props }) => {
  const dispatch = useDispatch();
  const searchQuery = useSelector(getGuestVisitSearchQuery);
  const userLocationOptions = useSelector(getUserLocationOptions);

  useEffect(() => {
    dispatch(fetchUserLocationOptions());
  }, []);
  useEffect(
    () => {
      if (isEmpty(userLocationOptions)) return;
      const query = {
        ...searchQuery,
        client_id: guestId,
        location_id: map('value', userLocationOptions)
      };
      dispatch(fetchGuestVisits(query));
      dispatch(updateGuestVisitSearchQuery(query));
    },
    [userLocationOptions]
  );

  return (
    <Panel {...props}>
      <Panel bordered style={{ marginBottom: 10 }}>
        <VisitSearch placeholder="Type tracking method or member name" />
      </Panel>
      <VisitsList />
    </Panel>
  );
};

VisitsSection.propTypes = {
  guestId: PropTypes.number.isRequired
};

export default VisitsSection;
